export default __webpack_public_path__ + "static/media/pgtocaixa.b62370e0.svg";